import axios from 'axios'

export async function uploadSingleFile(file, subFolder, renameFile, meta) {
  try {
    const options = {
      folder: subFolder,
      name: renameFile || file.name,
      type: file.type,
      meta: meta
    }

    const presignedData = await generatePresignedUrl(options)

    const config = {
      headers: {
        'Content-Type': file.type,
        'x-file-upload-header': 'file_upload'
      }
    }

    const response = await upload(presignedData.url, file, config)

    response.config = {
      ...options,
      folder: presignedData.folder
    }

    return response
  } catch (error) {
    throw new Error(error)
  }
}

export async function generatePresignedUrl(options) {
  try {
    const response = await axios.post(
      process.env.VUE_APP_RECEPIENTS_BASE_URL + '/generatePresigned',
      options
    )

    return response.data
  } catch (error) {
    throw new Error('W2P_GENERATE_PRESIGNED_FAILED')
  }
}

export function upload(url, data, options) {
  try {
    return axios.put(url, data, options)
  } catch (error) {
    throw new Error('W2P_S3_UPLOAD_FAILED')
  }
}

export function getFileFolderId(folder) {
  return folder.split('/')[1]
}

export async function isPdfReady(folderId) {
  try {
    const response = await axios.post(
      process.env.VUE_APP_PDF_BASE_URL + '/ispdfready',
      {
        uuid: folderId
      }
    )

    return response.data
  } catch (error) {
    throw new Error(error.message)
  }
}

export async function generatePreview(options) {
  try {
    const response = await axios.post(
      process.env.VUE_APP_PDF_BASE_URL + '/preview',
      options
    )

    return response.data
  } catch (error) {
    throw new Error(error.message)
  }
}

export async function isPreviewReady(folderId) {
  try {
    const response = await axios.post(
      process.env.VUE_APP_PDF_BASE_URL + '/ispreviewready',
      {
        uuid: folderId
      }
    )

    return response.data
  } catch (error) {
    throw new Error(error.message)
  }
}
